import type { CompanyData } from './types';
import { electroop } from './electroop';
import { piconbello } from './piconbello';
import { ailancer } from './ailancer';
import { yusufhantas } from './yusufhantas';
import { zenitova } from './zenitova';

export const customers: CompanyData[] = [
  electroop,
  piconbello,
  ailancer,
  yusufhantas,
];

export const admin: CompanyData = zenitova;

export {
  electroop,
  zenitova,
  piconbello,
};